/**
 * KAN-724: письма в ящик организации без привязки к клиенту.
 *
 *   GET  /api/v1/emails/unmatched/?search=&page=&page_size=
 *   GET  /api/v1/emails/unmatched/count/                  - {count}
 *   GET  /api/v1/emails/unmatched/{id}/                   - с телом и вложениями
 *   GET  /api/v1/emails/unmatched/{id}/attachments/{i}/   - файл вложения
 *   POST /api/v1/emails/unmatched/{id}/assign/            - {client_id}
 *   POST /api/v1/emails/unmatched/{id}/create-client/     - {name?, company?}
 *   POST /api/v1/emails/unmatched/{id}/dismiss/
 */
import apiClient from './client';
import type {
  CreateClientFromEmailBody,
  UnmatchedEmailAssignResult,
  UnmatchedEmailDetail,
  UnmatchedEmailListParams,
  UnmatchedEmailListResponse,
} from '@/types/emailMailbox';

const BASE = '/api/v1/emails/unmatched/';

function cleanParams(params: UnmatchedEmailListParams): Record<string, string | number> {
  const out: Record<string, string | number> = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') out[key] = value;
  });
  return out;
}

export const unmatchedEmailsApi = {
  list: async (params: UnmatchedEmailListParams): Promise<UnmatchedEmailListResponse> =>
    (await apiClient.get(BASE, { params: cleanParams(params) })).data,
  count: async (): Promise<{ count: number }> => (await apiClient.get(`${BASE}count/`)).data,
  get: async (id: string): Promise<UnmatchedEmailDetail> => (await apiClient.get(`${BASE}${id}/`)).data,
  assign: async (id: string, clientId: string): Promise<UnmatchedEmailAssignResult> =>
    (await apiClient.post(`${BASE}${id}/assign/`, { client_id: clientId })).data,
  createClient: async (id: string, body: CreateClientFromEmailBody): Promise<UnmatchedEmailAssignResult> =>
    (await apiClient.post(`${BASE}${id}/create-client/`, body)).data,
  dismiss: async (id: string): Promise<{ id: string; status: 'dismissed' }> =>
    (await apiClient.post(`${BASE}${id}/dismiss/`)).data,
  /** Файл вложения (запрос с токеном, поэтому blob, а не прямая ссылка). */
  attachment: async (id: string, index: number): Promise<Blob> =>
    (await apiClient.get(`${BASE}${id}/attachments/${index}/`, { responseType: 'blob' })).data,
};
